"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAnswerDataMobileFormat = exports.generateItemData = exports.generateItemAttributesFromListSchema = exports.generateItemFromListData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const es_1 = require("@faker-js/faker/locale/es");
const tools_1 = require("../tools");
const types_1 = require("../types");
const generateItemFromListData = (list) => {
    return Object.assign(Object.assign({}, (0, exports.generateItemAttributesFromListSchema)(list.schema)), { _id: (0, tools_1.IDSource)(), _list_id: list.id, _client_id: list.client_id, _created_at: new Date(), _updated_at: new Date(), _active: true });
};
exports.generateItemFromListData = generateItemFromListData;
const generateItemAttributesFromListSchema = (schema) => {
    let item = {};
    for (const attr of schema) {
        switch (attr.type) {
            case types_1.CUSTOM_FIELD_TYPE.INTEGER: {
                item[attr.column_tag] = en_1.faker.number.int({ min: 1, max: 100 });
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.DECIMAL: {
                item[attr.column_tag] = en_1.faker.number.float({
                    min: 1,
                    max: 5,
                    multipleOf: 0.01,
                });
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.TEXT: {
                item[attr.column_tag] = en_1.faker.word.words(3);
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.BOOLEAN: {
                item[attr.column_tag] = en_1.faker.datatype.boolean();
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.DATE_PICKER: {
                item[attr.column_tag] = en_1.faker.date.past({ years: 2 }).toISOString();
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE: {
                if (!attr.options) {
                    throw new Error("the options field should be an array.");
                }
                item[attr.column_tag] = en_1.faker.helpers.arrayElement(attr.options).key;
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
                if (!attr.options) {
                    throw new Error("the options field should be an array.");
                }
                item[attr.column_tag] = attr.options
                    .map((o) => o.key)
                    .reduce((a, b, index) => (Object.assign(Object.assign({}, a), { 
                    // first element is always selected, so the generated value is never empty
                    [b]: index === 0 ? true : en_1.faker.datatype.boolean() })), {});
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.SIGNATURE:
            case types_1.CUSTOM_FIELD_TYPE.PICTURE: {
                const randomId = en_1.faker.string.alphanumeric(10);
                item[attr.column_tag] = {
                    url: `pic-${randomId}.jpg`,
                    upload_id: randomId,
                };
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.GPS: {
                item[attr.column_tag] = {
                    lat: en_1.faker.number.float({ min: 37, max: 39, multipleOf: 0.000001 }),
                    lng: en_1.faker.number.float({ min: 2, max: 3, multipleOf: 0.000001 }),
                    acc: en_1.faker.number.float({ min: 0, max: 100 }),
                };
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.PHONE_NUMBER: {
                item[attr.column_tag] =
                    "+" + en_1.faker.number.int({ min: 100000000, max: 999999999 });
                break;
            }
            case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
                item[attr.column_tag] = en_1.faker.string.alphanumeric(10);
                break;
            }
        }
    }
    return item;
};
exports.generateItemAttributesFromListSchema = generateItemAttributesFromListSchema;
/**
 *
 * @param list
 * @param itemIds : map of listid and itemid (has to be used for SCOL and MCOL questions)
 * @returns
 */
const generateItemData = (list, itemIds = {}) => {
    const attributesData = generateAttributesDataMobileFormat(list.schema, itemIds);
    return {
        id: (0, tools_1.IDSource)(),
        owners: [],
        created_locally_at: en_1.faker.date.recent().toISOString(),
        attributes: attributesData,
    };
};
exports.generateItemData = generateItemData;
const generateAttributesDataMobileFormat = (attributes, itemIds = {}) => {
    return attributes.map((attribute) => generateListSchemaDataMobileFormat(attribute, itemIds));
};
const generateAnswerDataMobileFormat = (question, itemIds = {}, lang = types_1.LANGUAGE.en) => {
    var _a, _b, _c;
    const currentFaker = {
        en: en_1.faker,
        es: es_1.faker,
        fr: en_1.faker,
    }[lang];
    let answer = {
        key: question.tag,
        value: "",
    };
    const matrix = question.matrix;
    switch (question.type) {
        case types_1.CUSTOM_FIELD_TYPE.UPLOAD_FILE:
        case types_1.CUSTOM_FIELD_TYPE.SIGNATURE:
        case types_1.CUSTOM_FIELD_TYPE.PICTURE: {
            answer.value = {
                url: currentFaker.image.url({ width: 640, height: 480 }),
                upload_id: (0, tools_1.IDSource)(),
            };
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.BARCODE_SCANNER:
        case types_1.CUSTOM_FIELD_TYPE.TEXT: {
            answer.value = currentFaker.lorem.word();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.INTEGER: {
            answer.value = currentFaker.number.int(30);
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.BOOLEAN: {
            answer.value = currentFaker.datatype.boolean();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.COMPUTE:
        case types_1.CUSTOM_FIELD_TYPE.DECIMAL: {
            answer.value = currentFaker.number.float({
                min: 1,
                max: 10,
                multipleOf: 0.01,
            });
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.PHONE_NUMBER: {
            answer.value = currentFaker.phone.number();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.RATING: {
            answer.value = currentFaker.number.int({ min: 1, max: 10 });
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.DATE_PICKER: {
            const date = new Date(currentFaker.number.int({
                min: 2015,
                max: 2023,
            }), currentFaker.number.int({
                min: 0,
                max: 11,
            }), currentFaker.number.int({
                min: 1,
                max: 30,
            }), 0, 0, 0, 0);
            answer.value = date.toISOString();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.TIME_PICKER: {
            const date = new Date(currentFaker.number.int({
                min: 2015,
                max: 2023,
            }), currentFaker.number.int({
                min: 0,
                max: 11,
            }), currentFaker.number.int({
                min: 1,
                max: 30,
            }), currentFaker.number.int({ min: 0, max: 23 }), currentFaker.number.int({
                min: 0,
                max: 59,
            }), 0, 0);
            answer.value = date.toISOString();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE: {
            let options = (_a = question === null || question === void 0 ? void 0 : question.options) === null || _a === void 0 ? void 0 : _a.map((opt) => opt.key);
            const option = currentFaker.helpers.arrayElement(currentFaker.helpers.shuffle(options));
            answer.value = option;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
            let options = (_b = question === null || question === void 0 ? void 0 : question.options) === null || _b === void 0 ? void 0 : _b.map((opt) => opt.key);
            options = currentFaker.helpers.arrayElements(currentFaker.helpers.shuffle(options), currentFaker.number.int({
                min: 1,
                max: options === null || options === void 0 ? void 0 : options.length,
            }));
            answer.value = options;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_TEXT: {
            const nb = currentFaker.number.int({ min: 1, max: 5 });
            const values = Array.from({ length: nb }, (_, __) => ({
                timestamp: new Date().toISOString(),
                value: currentFaker.lorem.word(),
            }));
            answer.value = values;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_INTEGER: {
            const nb = currentFaker.number.int({ min: 1, max: 5 });
            const values = Array.from({ length: nb }, (_, __) => ({
                timestamp: new Date().toISOString(),
                value: currentFaker.number.int({ min: 1, max: 1000 }),
            }));
            answer.value = values;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_DECIMAL: {
            const nb = currentFaker.number.int({ min: 1, max: 5 });
            const values = Array.from({ length: nb }, (_, __) => ({
                timestamp: new Date().toISOString(),
                value: currentFaker.number.float({
                    min: 1,
                    max: 2000,
                    multipleOf: 0.01,
                }),
            }));
            answer.value = values;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
            answer.value = currentFaker.helpers.arrayElements(currentFaker.helpers.shuffle(itemIds[question === null || question === void 0 ? void 0 : question.list_id]), 1)[0];
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST: {
            answer.value = currentFaker.helpers.arrayElements(currentFaker.helpers.shuffle(itemIds[question === null || question === void 0 ? void 0 : question.list_id]), currentFaker.number.int({
                min: 1,
                max: itemIds[question.list_id].length,
            }));
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.GPS: {
            answer.value = {
                acc: currentFaker.number.int(12),
                lng: currentFaker.number.float({ min: 1, max: 15, multipleOf: 0.01 }),
                lat: currentFaker.number.float({ min: 1, max: 14, multipleOf: 0.01 }),
            };
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST: {
            if (matrix) {
                let headers = [];
                const randomIds = itemIds[question === null || question === void 0 ? void 0 : question.list_id]
                    ? currentFaker.helpers.arrayElements(currentFaker.helpers.shuffle(itemIds[question === null || question === void 0 ? void 0 : question.list_id]), currentFaker.datatype.number((_c = itemIds[question === null || question === void 0 ? void 0 : question.list_id]) === null || _c === void 0 ? void 0 : _c.length))
                    : [];
                for (const header of randomIds) {
                    let subQuestionAnswers = [];
                    for (const subQuestion of matrix.typed_questions) {
                        const generatedAnswerForSubQuestion = (0, exports.generateAnswerDataMobileFormat)(subQuestion, itemIds);
                        subQuestionAnswers.push(generatedAnswerForSubQuestion);
                    }
                    headers.push({
                        typed_answers: subQuestionAnswers,
                        tag: header,
                    });
                }
                answer.value = {
                    headers: headers,
                };
            }
            else {
                /* valObj = {
                  headerKey1: {
                    subQuestionTag1: currentFaker.lorem.words(),
                    subQuestionTag2: currentFaker.lorem.words(),
                  },
                  headerKey2: {
                    subQuestionTag1: currentFaker.lorem.words(),
                    subQuestionTag2: currentFaker.lorem.words(),
                  },
                };
              }
              answer.value = valObj; */
            }
            break;
        }
        default:
            answer.value = currentFaker.lorem.word();
            break;
    }
    return answer;
};
exports.generateAnswerDataMobileFormat = generateAnswerDataMobileFormat;
const generateListSchemaDataMobileFormat = (listSchema, itemIds = {}) => {
    var _a, _b;
    let answer = {
        key: listSchema.column_tag,
        value: "",
    };
    switch (listSchema.type) {
        case types_1.CUSTOM_FIELD_TYPE.SIGNATURE:
        case types_1.CUSTOM_FIELD_TYPE.UPLOAD_FILE:
        case types_1.CUSTOM_FIELD_TYPE.PICTURE: {
            answer.value = null;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.BARCODE_SCANNER:
        case types_1.CUSTOM_FIELD_TYPE.TEXT: {
            answer.value = en_1.faker.lorem.word();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.INTEGER: {
            answer.value = en_1.faker.number.int(30);
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.DECIMAL: {
            answer.value = en_1.faker.number.float({
                min: 1,
                max: 10,
                multipleOf: 0.01,
            });
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.PHONE_NUMBER: {
            answer.value = en_1.faker.phone.number();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE: {
            let options = (_a = listSchema === null || listSchema === void 0 ? void 0 : listSchema.options) === null || _a === void 0 ? void 0 : _a.map((opt) => opt.key);
            answer.value = en_1.faker.helpers.arrayElement(en_1.faker.helpers.shuffle(options));
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
            let options = (_b = listSchema === null || listSchema === void 0 ? void 0 : listSchema.options) === null || _b === void 0 ? void 0 : _b.map((opt) => opt.key);
            options = en_1.faker.helpers.arrayElements(en_1.faker.helpers.shuffle(options), en_1.faker.number.int({
                min: 1,
                max: options === null || options === void 0 ? void 0 : options.length,
            }));
            answer.value = options;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
            answer.value = {
                id: en_1.faker.helpers.arrayElement(en_1.faker.helpers.shuffle(itemIds[listSchema === null || listSchema === void 0 ? void 0 : listSchema.list_id])),
                list_id: listSchema.list_id,
            };
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.GPS: {
            answer.value = {
                acc: en_1.faker.number.float(12),
                lng: en_1.faker.number.float({ min: 1, max: 15, multipleOf: 0.01 }),
                lat: en_1.faker.number.float({ min: 1, max: 14, multipleOf: 0.01 }),
            };
            break;
        }
        default:
            answer.value = en_1.faker.lorem.word();
            break;
    }
    return answer;
};
